import "core-js/modules/es.array.concat.js";
import { getIsProduction } from "@faire/help-center-utils/serialized-data/getEnvName";
export var buildMobileChatUrl = function buildMobileChatUrl(issueType, brandOrderToken) {
  var domain = buildDomain();
  var issueTypeParam = "issue-type=".concat(issueType);
  var brandOrderTokenParam = brandOrderToken ? "&brand-order-token=".concat(brandOrderToken) : "";
  var redirectUrl = "".concat(domain, "://show-chat?").concat(issueTypeParam).concat(brandOrderTokenParam);
  return redirectUrl;
};
var buildDomain = function buildDomain() {
  var isProduction = getIsProduction();
  var environment = isProduction ? "" : "staging.";
  var domain = "com.faire.retailer.".concat(environment, "support-chat");
  return domain;
};